import { createFileRoute, useRouter } from '@tanstack/react-router';
import type { MouseEvent } from 'react';

import { ConversationTranscript } from '../../../../../components/ConversationTranscript.js';
import { useConversationsSection } from '../../../../../conversations/section.js';
import { useIsListDetailPane } from '../../../../../frame/breakpoints.js';

/**
 * `/websites/:websiteId/conversations/:conversationId`. At 1180px and wider the
 * transcript fills the pane beside the list; below, it is its own view, and
 * resizing across 1180px keeps it open (`patterns/ui-patterns.md`, 5). The
 * conversation belongs to the website in the URL; a mismatch is not found.
 */
export const Route = createFileRoute('/_app/websites/$websiteId/conversations/$conversationId')({
  component: ConversationDetail,
});

function ConversationDetail() {
  const { conversationId } = Route.useParams();
  const { websiteId, page, openedId } = useConversationsSection();
  const isPane = useIsListDetailPane();
  const router = useRouter();

  // Opened from the list in this visit: "Back to conversations" is the
  // browser's Back, so the list comes back with its page and scroll position
  // (`patterns/ui-patterns.md`, 5). Opened from a link, it goes to the list.
  const onBack =
    openedId === conversationId
      ? (event: MouseEvent<HTMLAnchorElement>) => {
          event.preventDefault();
          router.history.back();
        }
      : undefined;

  return (
    <ConversationTranscript
      key={conversationId}
      websiteId={websiteId}
      conversationId={conversationId}
      isOwnView={!isPane}
      back={{ page, onBack }}
    />
  );
}
